module.exports = __webpack_public_path__ + "c85b92d4c5f9d21c2e7e6994646ac682.pdf";